/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TaskInfo,
    TaskInfoFromJSON,
    TaskInfoFromJSONTyped,
    TaskInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface AIModelExportResponse
 */
export interface AIModelExportResponse {
    /**
     * 
     * @type {TaskInfo}
     * @memberof AIModelExportResponse
     */
    task: TaskInfo;
}

export function AIModelExportResponseFromJSON(json: any): AIModelExportResponse {
    return AIModelExportResponseFromJSONTyped(json, false);
}

export function AIModelExportResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AIModelExportResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'task': TaskInfoFromJSON(json['task']),
    };
}

export function AIModelExportResponseToJSON(value?: AIModelExportResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'task': TaskInfoToJSON(value.task),
    };
}


